export default function SciPy_Spatial_Data() {
  return (
    <div>
      <h1>SciPy Spatial Data</h1>
    </div>
  );
}
